import { HStack } from '@/components/sgBootstrapReactWrapper';
import type { Root } from '@/model/Root';
import { isDefined } from '@/utils/assertions';
import { SubtextEmphasizer } from '../common/SubtextEmphasizer';
import RootStatusBadge from './RootStatusBadge';
import RootTypeBadge from './RootTypeBadge';

type Props = {
  root: Root;
  emphasizedText: string;
};

export const RootCard = ({
  root: { rootId, legalName, shortName, rootType, rootStatus },
  emphasizedText,
}: Props) => {
  return (
    <div className="row px-12px py-16px border-bottom w-100 g-8px" data-e2e="root-card">
      <div className="col-8">
        <HStack className="fw-medium text-nowrap" horizontalAlignment="start">
          <em className="icon text-secondary pe-8px">account_balance</em>
          <div>
            {rootId}
            &nbsp;-&nbsp;
            <SubtextEmphasizer content={shortName ?? '?'} sub={emphasizedText} />
            &nbsp;-&nbsp;
            <SubtextEmphasizer content={legalName ?? '?'} sub={emphasizedText} />
          </div>
        </HStack>
      </div>
      <HStack className="col-3" horizontalAlignment="end">
        {isDefined(rootType) && <RootTypeBadge rootType={rootType} />}
      </HStack>
      <HStack className="col-1" horizontalAlignment="start">
        {isDefined(rootStatus) && <RootStatusBadge rootStatus={rootStatus} />}
      </HStack>
    </div>
  );
};
